(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('startupTransitionHook', startupTransitionHook);

    startupTransitionHook.$inject = ['user', 'clubAdminStateName', 'associationAdminStateName', 'homeStateName'];
    function startupTransitionHook(user, clubAdminStateName, associationAdminStateName, homeStateName) {
        return {
            onBefore: [{ to: homeStateName, from: ''}, startHook]
        };

        function startHook(transition) {
            var target = transition.router.stateService.target,
                isAdmin = user.isAdmin,
                isAssociationAdmin = user.isAssociationAdmin;

            if (isAdmin)
                return target(isAssociationAdmin ? associationAdminStateName : clubAdminStateName);
        }
    }
})();